import { PassedInitialConfig } from 'angular-auth-oidc-client';

import { environment } from 'src/environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.cognito.authority,
    redirectUrl: environment.cognito.redirectUrl,
    postLogoutRedirectUri: environment.cognito.postLogoutRedirectUri,
    clientId: environment.cognito.clientId,
    scope: environment.cognito.scope,
    responseType: environment.cognito.responseType,
    silentRenew: environment.cognito.silentRenew,
    useRefreshToken: environment.cognito.useRefreshToken,
    renewTimeBeforeTokenExpiresInSeconds:
      environment.cognito.renewTimeBeforeTokenExpiresInSeconds,
  },
};
